import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatBytes(
  bytes: number,
  opts: {
    decimals?: number;
    sizeType?: 'accurate' | 'normal';
  } = {},
) {
  const { decimals = 0, sizeType = 'normal' } = opts;

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const accurateSizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB'];
  if (bytes === 0) return '0 Byte';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(decimals)} ${sizeType === 'accurate' ? accurateSizes[i] ?? 'Bytes' : sizes[i] ?? 'Bytes'
    }`;
}

/**
 * 持续检查 localStorage 中的 userdatainfo，直到找到后返回 Promise
 * @returns {Promise<any>} 返回包含 userdatainfo 的 Promise
 */
export function waitForUserDataInfo() {
  let timer: any
  return new Promise((resolve) => {
    // 递归检查函数
    const checkForData = () => {
      const userDataInfo = localStorage.getItem('userdatainfo');

      if (userDataInfo) {
        // 如果找到数据，解析并返回
        try {
          const parsedData = JSON.parse(userDataInfo);
          resolve(parsedData);
        } catch (error) {
          // 如果 JSON 解析失败，返回原始字符串
          resolve(userDataInfo);
        }
      } else {
        // 如果没找到，继续检查（间隔 500ms）
        clearTimeout(timer)
        timer = setTimeout(checkForData, 500);
      }
    };

    // 开始检查
    checkForData();
  });
}